import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {ConfigService} from '@app/@core/@config/config.service';

@Injectable({
  providedIn: 'root',
})
export class MatchesUrlSectionGuard implements CanActivate {
  constructor(private router: Router, private configService: ConfigService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const networkData = this.configService.getNetworkData();
    if (this.configService.networkKnownFromDomain()) {
      return this.router.createUrlTree(['/404']);
    } else if (networkData && route.paramMap.get('network') === networkData.urlSection) {
      return true;
    } else if (window.location.host === 'adme.mediasquare.fr') {
      window.location.href = 'https://admanager.mediasquare.fr/';
      return false;
    } else {
      return this.router.createUrlTree(['/sign-in-404']);
    }
  }
}
